/* Boreal Gaming — desktop mega menu behaviour (snippets/boreal-mega-menu).
   Hover (with a short delay) or click opens a panel; Esc, clicking outside,
   or tabbing away closes it. The phone drawer uses the theme's own code. */
(function () {
  var nav = document.querySelector('[data-bm-nav]');
  if (!nav || nav.dataset.bmReady) return;
  nav.dataset.bmReady = '1';

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var openItem = null;
  var openTimer = null;
  var closeTimer = null;

  function parts(li) {
    return { btn: li.querySelector('[data-bm-trigger]'), panel: li.querySelector('[data-bm-panel]') };
  }

  function close() {
    if (!openItem) return;
    var p = parts(openItem);
    p.btn.setAttribute('aria-expanded', 'false');
    p.panel.hidden = true;
    openItem = null;
    nav.classList.remove('bm-is-open');
  }

  function open(li) {
    if (openItem === li) return;
    close();
    var p = parts(li);
    if (!p.btn || !p.panel) return;
    p.btn.setAttribute('aria-expanded', 'true');
    p.panel.hidden = false;
    openItem = li;
    nav.classList.add('bm-is-open');
  }

  // Hover with intent delay (desktop mice only)
  nav.addEventListener('mouseover', function (e) {
    if (!canHover.matches) return;
    var li = e.target.closest('.bm-item');
    if (!li || !nav.contains(li)) return;
    clearTimeout(closeTimer);
    clearTimeout(openTimer);
    if (li === openItem) return;
    if (!li.querySelector('[data-bm-trigger]')) {
      openTimer = setTimeout(close, 150);
      return;
    }
    openTimer = setTimeout(function () { open(li); }, openItem ? 60 : 150);
  });

  nav.addEventListener('mouseleave', function () {
    if (!canHover.matches) return;
    clearTimeout(openTimer);
    closeTimer = setTimeout(close, 250);
  });

  // Click / tap / Enter toggles
  nav.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bm-trigger]');
    if (!btn) return;
    e.preventDefault();
    clearTimeout(openTimer);
    var li = btn.closest('.bm-item');
    if (openItem === li) close(); else open(li);
  });

  // Keyboard
  nav.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openItem) {
      var btn = parts(openItem).btn;
      close();
      btn.focus();
    }
  });

  nav.addEventListener('focusout', function (e) {
    if (e.relatedTarget && !nav.contains(e.relatedTarget)) close();
  });

  document.addEventListener('click', function (e) {
    if (openItem && !nav.contains(e.target)) close();
  });

  // Close when crossing into the phone layout
  window.matchMedia('(max-width: 999px)').addEventListener('change', close);
})();
